import { fade } from "../utils/color.js";
export default function createTagPalette(theme, current, _base) {
    return {
        tag: {
            "filled": {
                color: current.contrast[500],
                backgroundColor: current[500],
                borderColor: current[500],
                hover: {
                    backgroundColor: current[400],
                    borderColor: current[400],
                },
                focus: {
                    boxShadowColor: current[500],
                },
                active: {
                    backgroundColor: current[600],
                    borderColor: current[600],
                },
                disabled: {
                    color: current.contrast[200],
                    backgroundColor: current[300],
                    borderColor: "transparent",
                },
                closeButton: {
                    active: {
                        boxShadowColor: current[200],
                    },
                },
            },
            "outline": {
                color: current[500],
                backgroundColor: "transparent",
                borderColor: current[500],
                hover: {
                    color: current[400],
                    backgroundColor: fade(current[500], 0.1),
                    borderColor: current[400],
                },
                focus: {
                    borderColor: current[600],
                    boxShadowColor: current[500],
                },
                active: {
                    color: current[600],
                    borderColor: current[600],
                },
                disabled: {
                    color: current[300],
                    borderColor: current[300],
                },
            },
            "faded": {
                color: current[500],
                backgroundColor: current[50],
                borderColor: "transparent",
                hover: {
                    color: current[400],
                    backgroundColor: current[100],
                },
                focus: {
                    boxShadowColor: current[500],
                },
                active: {
                    color: current[600],
                    backgroundColor: current[25],
                },
                disabled: {
                    color: current[300],
                    backgroundColor: current[25],
                },
            },
            "faded-outline": {
                color: current[500],
                backgroundColor: "transparent",
                borderColor: current[50],
                hover: {
                    color: current[400],
                    backgroundColor: fade(current[500], 0.1),
                    borderColor: current[100],
                },
                focus: {
                    boxShadowColor: current[500],
                },
                active: {
                    color: current[600],
                },
                disabled: {
                    color: current[300],
                    borderColor: current[25],
                },
            },
        },
    };
}
//# sourceMappingURL=tag.js.map